import { useEffect, useRef, useState } from 'react';

const TIMER_DURATION = 600; // 10 minutes

function useCheckoutTimer() {
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const [timeLeft, setTimeLeft] = useState<number>(TIMER_DURATION);
  const isExpired = timeLeft <= 0;

  const resetTimer = () => {
    setTimeLeft(TIMER_DURATION);
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      clearInterval(timerRef.current);
      timerRef.current = undefined;
    } else if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }
    };
  }, [timeLeft]);

  return {
    timeLeft,
    isExpired,
    resetTimer
  };
}

export default useCheckoutTimer;
